import {
  getServiceRequestSalesTaxFlow,
  SalesTaxFlow,
  TSalesTaxFlow,
} from '@commenda/types';
import { SalesTaxFilingTasks } from '@commenda/types/src/sales-tax/types';
import {
  ServiceRequestDetails,
  TSrPageTask,
} from '@commenda/types/src/service-request/types';

type TReportedTaskLabelRule = {
  salesTaxFlow: TSalesTaxFlow;
  taskId: string;
  label: string;
};

const REPORTED_TASK_LABEL_RULES: TReportedTaskLabelRule[] = [
  {
    salesTaxFlow: SalesTaxFlow.SALES_TAX_FILING,
    taskId: SalesTaxFilingTasks.REVIEW_TRANSACTIONS,
    label: 'Sent back for re-review',
  },
];

export const getCompletedTaskLabel = ({
  task,
  serviceRequest,
}: {
  task: Pick<
    TSrPageTask,
    'legacyServiceRequestTaskTaskId' | 'metadata' | 'title'
  >;
  serviceRequest: Pick<
    ServiceRequestDetails,
    'salesTaxFilingId' | 'salesTaxRegistrationId' | 'salesTaxFlow'
  >;
}) => {
  const defaultLabel = `${task.title} completed`;

  if (task.metadata?.isIssueReported !== true) return defaultLabel;

  return (
    REPORTED_TASK_LABEL_RULES.find(
      (rule) =>
        rule.salesTaxFlow === getServiceRequestSalesTaxFlow(serviceRequest) &&
        rule.taskId === task.legacyServiceRequestTaskTaskId
    )?.label ?? defaultLabel
  );
};
